/**
 * Coerce API value to string for React children.
 * Handles translatable objects like { en: '...', ar: '...' } so we never render an object.
 * See docs/DISPLAY_TEXT_RULE.md and .cursorrules "Display Text" section for usage rule.
 *
 * @param {*} value - Any value (string, object with en/ar, etc.)
 * @param {string} [lang='en'] - Language key ('en' or 'ar')
 * @returns {string} Safe string for rendering
 */
export function toDisplayText(value, lang = 'en') {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && !Array.isArray(value) && ('en' in value || 'ar' in value)) {
    const s = lang === 'ar' ? (value.ar ?? value.en) : (value.en ?? value.ar);
    return s != null && typeof s === 'string' ? s : '';
  }
  return String(value);
}
